var map = {
	"./client/app/home-page/home-news/home-news.component": [
		"7tvy"
	],
	"./custom/app/home-page/home-news/home-news.component": [
		"z6q1",
		98
	],
	"./dspace/app/home-page/home-news/home-news.component": [
		"6yqo",
		160
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "V30M";
module.exports = webpackAsyncContext;